/**
 * @namespace PIXI.glCore
 * @private
 */
/**
 * @namespace PIXI.glCore.shader
 * @private
 */
export * from './compileProgram';
export * from './defaultValue';
export * from './getMaxFragmentPrecision';
export * from './setPrecision';
export * from './mapSize';
export * from './mapType';
export * from './generateUniformsSync';
export * from './uniformParsers';
export * from './getTestContext';
export * from './checkMaxIfStatementsInShader';
export * from './unsafeEvalSupported';
